module.exports = __webpack_public_path__ + "img/158.cc11f540.jpg";